import { useMemo } from 'react';
import { EMPTY_LABEL_VALUE } from '../../components/Dropdown/constants';
export var useSelectedValueToDisplay = function useSelectedValueToDisplay(internalValue, internalOptions, onRenderSelectedValue) {
  return useMemo(function () {
    if (onRenderSelectedValue) {
      return onRenderSelectedValue(internalValue, internalOptions);
    }

    if (!internalValue.length) {
      return EMPTY_LABEL_VALUE;
    }

    return internalOptions.filter(function (option) {
      return internalValue.includes(option.value);
    }).map(function (option) {
      return option.label;
    }).join(', ');
  }, [onRenderSelectedValue, internalValue, internalOptions]);
};